// smithy-typescript generated code
import { Apiv2Client } from "../Apiv2Client";
import { ListEditorSessionsCommand, } from "../commands/ListEditorSessionsCommand";
import { createPaginator } from "@smithy/core";
/**
 * @public
 */
export const paginateListEditorSessions = createPaginator(Apiv2Client, ListEditorSessionsCommand, "nextToken", "nextToken", "pageSize");
